const NAV_BAR_HEIGHT = 5.5;
const NAV_BAR_HEIGHT_SM = 4;
const UNIFY_BAR_HEIGHT = 0.25;
const NAV_TABS_HEIGHT = 3;
const NAV_TABS_GAP_HEIGHT = 0.5;
const NAV_TABS_SUB_TAB_HEIGHT = 104;

export const HeaderConstants = {
  NAV_BAR_HEIGHT,
  NAV_BAR_HEIGHT_SM,
  UNIFY_BAR_HEIGHT,
  NAV_TABS_HEIGHT,
  NAV_TABS_GAP_HEIGHT,
  NAV_TABS_SUB_TAB_HEIGHT,
} as const;
